import * as React from 'react';

import { ILxsContactProps } from './lxs-contact.props.autogenerated';

export interface ILxsContactViewProps extends ILxsContactProps<{}> {}

/**
 *
 * LxsContact component
 * @extends {React.PureComponent<ILxsContactProps<ILxsContactData>>}
 */
class LxsContact extends React.PureComponent<ILxsContactProps<{}>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LxsContact;
